module.exports = __webpack_public_path__ + "img/area_ac.cb8643ff.png";